import { c as _c } from "react/compiler-runtime";
import { SelectProjectRole } from "@components/role/select-project-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { RemoveFromProjectDialog } from "@components/project/remove-from-project-dialog";
import { useProjectMemberActions } from "@hooks/projects/use-project-member-actions";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";
import { useState } from "react";
/** Render and adjust member roles in project context. */
export function ProjectMemberRole(t0) {
  const $ = _c(38);
  const {
    companyId,
    project,
    memberIdentityRole,
    isReadOnly: t1,
    location,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const memberActions = useProjectMemberActions(project);
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  let t2;
  if ($[0] !== companyId || $[1] !== location || $[2] !== memberIdentityRole.identity || $[3] !== memberIdentityRole.role || $[4] !== project) {
    t2 = {
      companyId,
      location,
      subjectType: "project",
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      selectedProject: project
    };
    $[0] = companyId;
    $[1] = location;
    $[2] = memberIdentityRole.identity;
    $[3] = memberIdentityRole.role;
    $[4] = project;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t2);
  let t3;
  if ($[6] !== memberActions || $[7] !== memberIdentityRole) {
    t3 = memberActions.canChangeRole(memberIdentityRole);
    $[6] = memberActions;
    $[7] = memberIdentityRole;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const canEditRole = t3;
  let t4;
  if ($[9] !== member || $[10] !== memberActions || $[11] !== memberIdentityRole) {
    t4 = !!member && memberActions.canRemove(memberIdentityRole);
    $[9] = member;
    $[10] = memberActions;
    $[11] = memberIdentityRole;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const canRemove = t4;
  if (isReadOnly) {
    let t5;
    if ($[13] !== memberIdentityRole.role) {
      t5 = <MemberRoleReadOnly role={memberIdentityRole.role} variant="borderless" />;
      $[13] = memberIdentityRole.role;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  if (!canEditRole && !canRemove) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        fontSize: DEFAULT_TEXT_FONT_SIZE
      };
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== memberIdentityRole.role) {
      t6 = formatUserRoleType(memberIdentityRole.role);
      $[16] = memberIdentityRole.role;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    let t7;
    if ($[18] !== t6) {
      t7 = <span style={t5}>{t6}</span>;
      $[18] = t6;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    return t7;
  }
  let t5;
  if ($[20] !== changeMemberRole) {
    t5 = async function onRoleChange(role) {
      try {
        await changeMemberRole(role);
      } catch {}
    };
    $[20] = changeMemberRole;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const onRoleChange = t5;
  const t6 = memberIdentityRole.role;
  let t7;
  if ($[22] !== canRemove) {
    t7 = canRemove ? () => setIsRemoveDialogOpen(true) : undefined;
    $[22] = canRemove;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== canEditRole || $[25] !== onRoleChange || $[26] !== t6 || $[27] !== t7) {
    t8 = <SelectProjectRole selectedRole={t6} onChange={onRoleChange} variant="borderless" isRoleEditable={canEditRole} onRemove={t7} />;
    $[24] = canEditRole;
    $[25] = onRoleChange;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== companyId || $[30] !== isRemoveDialogOpen || $[31] !== location || $[32] !== member || $[33] !== project) {
    t9 = member && isRemoveDialogOpen && <RemoveFromProjectDialog companyId={companyId} project={project} member={member} location={location} onClose={() => setIsRemoveDialogOpen(false)} />;
    $[29] = companyId;
    $[30] = isRemoveDialogOpen;
    $[31] = location;
    $[32] = member;
    $[33] = project;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t8 || $[36] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}